module.exports = __webpack_public_path__ + "assets/80ddbf4f0fdde4ddba57130e61043017.js";